export const REACT_WINDOW_CLASS_NAME = 'rubicon-virtualized-window';
